import { createSlice } from "@reduxjs/toolkit";
import {
  createNewsBuilder,
  deleteNewsBuilder,
  editNewsBuilder,
  getNewsBuilder,
  getFeaturedNewsBuilder,
  getNewsByIdBuilder,
  toggleNewsStatusBuilder,
  getNewsDetailsBuilder,
  updateNewsDetailsBuilder,
  createNewsDetailsBuilder,
  getNewsPublicDetailsBuilder,
} from "./builder";

const initialState = {
  news: {
    data: [],
    total: 0,
    page: 1,
    perPage: 12,
    maxReached: false,
    loading: false,
    createLoading: false,
    deleteLoading: false,
    toggleLoading: false,
    editLoading: false,
    error: null,
  },

  newsById: {
    data: null,
    loading: false,
    error: null,
  },

  featuredNews: {
    data: [],
    loading: false,
    error: null,
  },

  // NOVI STATES ZA DETAILS
  newsDetails: {
    data: null,
    loading: false,
    updateLoading: false,
    createLoading: false,
    error: null,
  },

  publicNewsDetails: {
    data: null,
    loading: false,
    error: null,
  },
};

export const newsSlice = createSlice({
  name: "newsInfo",
  initialState,
  reducers: {
    clearFeaturedNewsError: (state) => {
      state.featuredNews.error = null;
    },

    // NOVI REDUCERS
    clearNewsDetails: (state) => {
      state.newsDetails.data = null;
      state.newsDetails.error = null;
    },

    clearPublicNewsDetails: (state) => {
      state.publicNewsDetails.data = null;
      state.publicNewsDetails.error = null;
    },

    resetNewsDetailsState: (state) => {
      state.newsDetails = {
        data: null,
        loading: false,
        updateLoading: false,
        createLoading: false,
        error: null,
      };
      state.publicNewsDetails = {
        data: null,
        loading: false,
        error: null,
      };
    },
  },

  extraReducers: (builder) => {
    // Postojeći builders
    getNewsBuilder(builder);
    getFeaturedNewsBuilder(builder);
    getNewsByIdBuilder(builder);
    editNewsBuilder(builder);
    deleteNewsBuilder(builder);
    createNewsBuilder(builder);
    toggleNewsStatusBuilder(builder);

    // NOVI BUILDERS
    getNewsDetailsBuilder(builder);
    updateNewsDetailsBuilder(builder);
    createNewsDetailsBuilder(builder);
    getNewsPublicDetailsBuilder(builder);

    // Handle logout
    builder.addCase("auth/logout", (state) => {
      return initialState;
    });
  },
});

// Export actions
export const {
  clearFeaturedNewsError,
  clearNewsDetails,
  clearPublicNewsDetails,
  resetNewsDetailsState,
} = newsSlice.actions;

// Selectors
export const selectNews = (state) => state.newsInfo.news;
export const selectNewsById = (state) => state.newsInfo.newsById;
export const selectFeaturedNews = (state) => state.newsInfo.featuredNews;

// NOVI SELECTORS
export const selectNewsDetails = (state) => state.newsInfo.newsDetails;
export const selectPublicNewsDetails = (state) =>
  state.newsInfo.publicNewsDetails;

export default newsSlice.reducer;
